import ListItem from "../ListItem/ListItem";
import "./ListItemGroup.scss";
import {
  CalendarBlankIcon,
  GridPresetOffsetWideContent,
  GridPresetWideList,
  GridRow,
  HideFor,
  InfoSmallIcon,
  MapPinIcon,
} from "/App.Components";
import { EventListItemProps } from "/Models/Generated/EventListItemProps";
import { EventListItemGroupProps } from "/Models/Generated/EventListItemGroupProps";

const EventListItemGroup: React.FC<EventListItemGroupProps> = ({
  sectionHeading,
  items,
}) => {
  const getMetadataItems = (item: EventListItemProps) => {
    return {
      firstRow: (item.date || item.location) && (
        <>
          {item.date && (
            <InfoSmallIcon text={item.date} icon={CalendarBlankIcon} />
          )}
          {item.location && (
            <InfoSmallIcon text={item.location} icon={MapPinIcon} />
          )}
        </>
      ),
    };
  };

  return (
    <li className="list-item-group-norad__group">
      <GridRow>
        <GridPresetOffsetWideContent>
          {sectionHeading && (
            <>
              <h2 className="list-item-group-norad__section-heading">
                {sectionHeading}
              </h2>
              <GridPresetWideList>
                <HideFor desktop desktopMedium desktopLargeUp>
                  <div className="list-item-group-norad__section-heading-divider"></div>
                </HideFor>
              </GridPresetWideList>
            </>
          )}
        </GridPresetOffsetWideContent>

        <ol className="list-item-group-norad__items">
          {items &&
            items.map((item, idx) => (
              <ListItem
                link={item.link}
                key={"list-item" + idx}
                metadataItems={getMetadataItems(item)}
                image={item.image}
                heading={item.heading}
                label={item.label}
              />
            ))}
        </ol>
      </GridRow>
      <GridRow>
        <GridPresetWideList>
          <HideFor mobile tablet>
            <div className="list-item-group-norad__divider"></div>
          </HideFor>
        </GridPresetWideList>
      </GridRow>
    </li>
  );
};

export default EventListItemGroup;
